export default __webpack_public_path__ + "static/media/14.3ea2396d.jpeg";